import React, { useRef, useEffect, useState } from "react"
import Link from "gatsby-plugin-transition-link"
import cn from "classnames"
import * as s from "./styles.module.scss"
import Image from "../../components/image"
import BigIconButton from "../../components/button/big-icon"
import ArrowRight from "~/assets/svg/arrow-right.svg"
import setObserver from "../../utils/setObserver"

type Props = {}

const Component: React.FC<Props> = () => {
  const links = {
    btob: "/method/btob/",
    btoc: "/method/btoc/",
    english: "/method/english/",
    global: "/method/global/",
  }

  const [showItem1, setShowItem1] = useState(false)
  const [showItem2, setShowItem2] = useState(false)
  const [showItem3, setShowItem3] = useState(false)
  const [showItem4, setShowItem4] = useState(false)
  const targetItem1 = useRef<HTMLDivElement>(null)
  const targetItem2 = useRef<HTMLDivElement>(null)
  const targetItem3 = useRef<HTMLDivElement>(null)
  const targetItem4 = useRef<HTMLDivElement>(null)

  const [showService1, setShowService1] = useState(false)
  const [showService2, setShowService2] = useState(false)
  const [showService3, setShowService3] = useState(false)
  const [showService4, setShowService4] = useState(false)
  const sceneEls = useRef<React.RefObject<HTMLDivElement>[]>([])
  const sceneData = [1, 2, 3, 4]

  sceneData.forEach((_, i) => {
    sceneEls.current[i] = React.createRef()
  })

  const setSceneState = (id: number, flag: boolean) => {
    switch (id) {
      case 1:
        setShowService1(flag)
        break
      case 2:
        setShowService2(flag)
        break
      case 3:
        setShowService3(flag)
        break
      case 4:
        setShowService4(flag)
        break
    }
  }

  useEffect(() => {
    const observerItem1 = setObserver(
      targetItem1.current,
      "0% 0% -15% 0%",
      setShowItem1,
      true
    )

    const observerItem2 = setObserver(
      targetItem2.current,
      "0% 0% -15% 0%",
      setShowItem2,
      true
    )

    const observerItem3 = setObserver(
      targetItem3.current,
      "0% 0% -15% 0%",
      setShowItem3,
      true
    )

    const observerItem4 = setObserver(
      targetItem4.current,
      "0% 0% -15% 0%",
      setShowItem4,
      true
    )

    const options = {
      root: null,
      threshold: 0,
      rootMargin: "-50% 0%",
    }

    const __setObserver = (target: HTMLElement, id: number) => {
      const callback: IntersectionObserverCallback = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setSceneState(id, true)
            // console.log("in ----- ", id)
          } else {
            setSceneState(id, false)
            // console.log("out ----- ", id)
          }
        })
      }

      const observer = new IntersectionObserver(callback, options)
      observer.observe(target)
    }

    sceneEls.current.map((el, i) => {
      if (el.current) __setObserver(el.current, sceneData[i])
    })
  }, [])

  return (
    <div className={s.list}>
      <div
        className={cn(s.item, {
          [s.active]: showService1,
          [s.show]: showItem1,
        })}
        ref={sceneEls.current[0]}
      >
        <div className={s.item_inner} ref={targetItem1}>
          <div className={s.mainImage}>
            <div className={s.image_wrap}>
              <div className={s.image}>
                <Image filename="service/index-btob-mob.jpg" alt="" />
              </div>
            </div>
          </div>

          <div className={s.text}>
            <p className={s.num}>01</p>
            <h3>
              学校・自治体向け
              <br />
              サービス
            </h3>
            <p className={s.description}>
              基礎知識学習から、進路選択、非認知能力育成まで。先生の業務をサポートし、生徒一人ひとりの可能性を切り拓きます。
            </p>
            <div className={s.link_pc}>
              <BigIconButton label="詳しくみる" href={links.btob} />
            </div>
          </div>

          <Link
            to={links.btob}
            entry={{
              length: 1,
            }}
            className={s.link_mob}
          >
            <div className={s.icon}>
              <div className={s.svg}>
                <ArrowRight />
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div
        className={cn(s.item, {
          [s.active]: showService2,
          [s.show]: showItem2,
        })}
        ref={sceneEls.current[1]}
      >
        <div className={s.item_inner} ref={targetItem2}>
          <div className={s.mainImage}>
            <div className={s.image_wrap}>
              <div className={s.image}>
                <Image filename="service/index-btoc-mob.jpg" alt="" />
              </div>
            </div>
          </div>

          <div className={s.text}>
            <p className={s.num}>02</p>
            <h3>
              小・中・高校生向け
              <br />
              サービス
            </h3>
            <p className={s.description}>
              学校の予習・復習から、受験勉強まで。一人ひとりに最適化された学びを提供し、希望する進路へと歩む力を育みます。
            </p>
            <div className={s.link_pc}>
              <BigIconButton label="詳しくみる" href={links.btoc} />
            </div>
          </div>

          <Link
            to={links.btoc}
            entry={{
              length: 1,
            }}
            className={s.link_mob}
          >
            <div className={s.icon}>
              <div className={s.svg}>
                <ArrowRight />
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div
        className={cn(s.item, {
          [s.active]: showService3,
          [s.show]: showItem3,
        })}
        ref={sceneEls.current[2]}
      >
        <div className={s.item_inner} ref={targetItem3}>
          <div className={s.mainImage}>
            <div className={s.image_wrap}>
              <div className={s.image}>
                <Image filename="service/index-english-mob.jpg" alt="" />
              </div>
            </div>
          </div>

          <div className={s.text}>
            <p className={s.num}>03</p>
            <h3>
              英語学習者向け
              <br />
              サービス
            </h3>
            <p className={s.description}>
              TOEIC®テスト対策、ビジネス英語、日常英会話、子ども向けなど。目的に応じて学べる、成果の出るオンライン英語学習サービスです。
            </p>
            <div className={s.link_pc}>
              <BigIconButton label="詳しくみる" href={links.english} />
            </div>
          </div>

          <Link
            to={links.english}
            entry={{
              length: 1,
            }}
            className={s.link_mob}
          >
            <div className={s.icon}>
              <div className={s.svg}>
                <ArrowRight />
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div
        className={cn(s.item, {
          [s.active]: showService4,
          [s.show]: showItem4,
        })}
        ref={sceneEls.current[3]}
      >
        <div className={s.item_inner} ref={targetItem4}>
          <div className={s.mainImage}>
            <div className={s.image_wrap}>
              <div className={s.image}>
                <Image filename="service/index-global-mob.jpg" alt="" />
              </div>
            </div>
          </div>

          <div className={s.text}>
            <p className={s.num}>04</p>
            <h3>
              海外現地向け
              <br />
              サービス
            </h3>
            <p className={s.description}>
              各国の学習カリキュラムを網羅したコンテンツを提供。最高のオンライン学習体験を世界で実現しています。
            </p>
            <div className={s.link_pc}>
              <BigIconButton label="詳しくみる" href={links.global} />
            </div>
          </div>

          <Link
            to={links.global}
            entry={{
              length: 1,
            }}
            className={s.link_mob}
          >
            <div className={s.icon}>
              <div className={s.svg}>
                <ArrowRight />
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div className={s.side}>
        <div className={s.sideImgs}>
          <div
            className={cn(s.image_wrap, s.image1, { [s.active]: showService1 })}
          >
            <div className={s.image}>
              <Image filename="service/index-btob.jpg" alt="" />
              {/* <Image filename="service/index-message-btob.png" alt="" /> */}
            </div>
          </div>

          <div
            className={cn(s.image_wrap, s.image2, { [s.active]: showService2 })}
          >
            <div className={s.image}>
              <Image filename="service/index-btoc.jpg" alt="" />
              {/* <Image filename="service/index-message-btoc.png" alt="" /> */}
            </div>
          </div>

          <div
            className={cn(s.image_wrap, s.image3, { [s.active]: showService3 })}
          >
            <div className={s.image}>
              <Image filename="service/index-english.jpg" alt="" />
              {/* <Image filename="service/index-message-english.png" alt="" /> */}
            </div>
            <div className={s.circle}></div>
          </div>

          <div
            className={cn(s.image_wrap, s.image4, { [s.active]: showService4 })}
          >
            <div className={s.image}>
              <Image filename="service/index-global.jpg" alt="" />
              {/* <Image filename="service/index-message-global.png" alt="" /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Component
